import {AuthService} from '../auth.service';
import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route} from '@angular/router';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {


  // tslint:disable-next-line:variable-name
  constructor(private _authService: AuthService, private _router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user = this._authService.decode();

    if (user && user.Role === next.data.role) {
      return true;
    } else {
      const currentState = history.state || {};
      console.log('role: ', next.data.role);
      currentState.role = next.data.role;
      switch (next.data.role) {
        case 'user':
          console.log(state.url);
          this._router.navigate(['login'],
            {queryParams: {returnUrl: state.url}, state: currentState}
          );
          break;
        case 'doctor':
          this._router.navigate(['doctor/login'],
            {queryParams: {returnUrl: state.url}, state: currentState}
          );
          break;
        case 'vet':
          this._router.navigate(['vet/login'],
            {queryParams: {returnUrl: state.url}, state: currentState}
          );
          break;
        case 'agent':
          this._router.navigate(['agent/login'],
            {queryParams: {returnUrl: state.url}, state: currentState}
          );
          break;
        case 'external-employee':
          this._router.navigate(['/login'],
            {
              queryParams: {
                returnUrl: state.url
              }, state: currentState
            }
          );
          break;
        default:
          console.log('user not recognized');
      }
    }
    return false;
  }

}
